import { useEffect } from 'react';
import { useLocation } from 'react-router';

let acquisition = {
  source: undefined,
  campaign: undefined,
};

const set = ({ source, campaign }) => (acquisition = { source, campaign });

const store = () =>
  localStorage.setItem('acquisition', JSON.stringify(acquisition));

export const get = () => {
  try {
    return JSON.parse(localStorage.getItem('acquisition'));
  } catch (err) {
    return acquisition;
  }
};

export default () => {
  const queryParams = new URLSearchParams(useLocation().search);
  set({
    source: queryParams.get('source'),
    campaign: queryParams.get('campaign'),
  });

  useEffect(() => {
    store();
  }, []);
};
